import {BrowserRouter, Route, Routes, Navigate} from "react-router-dom";
import { useEffect } from "react";
import {PrivateRoute} from './auth';
import Login from './cbt_lms/login';
import SignUp from './cbt_lms/sign_up_';

// blogposts

// admin, unit, staff, course  portal 
import Admindashboard from './cbt_lms/admin/dashboard';
import { TestResult } from './cbt_lms/admin/test_result';
import { TestData } from './cbt_lms/admin/test_data';
import { Cbt } from './cbt_lms/admin/create_cbt';
import { CbtData } from './cbt_lms/admin/cbt_data';
import { CbtImgLibrary } from './cbt_lms/admin/img_library';
import { CbtQuestionEdit } from './cbt_lms/admin/cbt_question_edit';
import CbtQuestion from './cbt_lms/student/cbt_question';
import Apikey from "./cbt_lms/admin/Apikey";
import PaymentPage from "./cbt_lms/admin/PaymentPage";

import { CbtPassCode } from './cbt_lms/student/cbt_pass_code';
import { CbtPassCodeVerification } from './cbt_lms/student/cbt_pass_code_verification';
import { QrsCbtPassCodeVerification } from "./cbt_lms/q_code_page";
import ExcelUpload from "./cbt_lms/admin/ExcelUpload";
import QuestionTransfer from "./cbt_lms/admin/QuestionTransfer";

import PasswordReset from './cbt_lms/password_reset';
import PasswordResetForm from './cbt_lms/change_password';
import Profile from './cbt_lms/profile';
import {HelmetProvider } from 'react-helmet-async';
import Receipt from "./cbt_lms/admin/receipt";
import TestCompletion from "./cbt_lms/student/TestCompletion";
import Analytics from "./cbt_lms/admin/analytics";
import SubscriptionUsers from "./cbt_lms/admin/SubscriptionUsers";
import JoinSubscription from "./cbt_lms/admin/JoinSubscription";
import CryptoPayment from "./cbt_lms/admin/CryptoPayment";
import UserInvitations from "./cbt_lms/admin/UserInvitations";
// import CbtQuestion from "./cbt_lms/student/cbt_question";

function App(){


  function ExternalRedirect() {
  useEffect(() => {
    window.location.href = "https://cbthost.com";
  }, []);
  return null;
}


  return(
    <HelmetProvider>
    <BrowserRouter>

    <Routes>

        {/* <Route index element={<Home />} /> */}
        <Route path="login" element={<Login />} />
        <Route path="sign-up" element={<SignUp />} />
        <Route path="password-reset" element={<PasswordReset />} />
        <Route path="password-reset-form" element={<PasswordResetForm />} />
         <Route path="/" element={<Navigate to="/login" replace />} />
         {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
         <Route path="*" element={<ExternalRedirect />} />
            <Route path="qr_verification" element={<QrsCbtPassCodeVerification />} />
            <Route path="receipt/:reference" element={<Receipt />} />
       
        {/*pages end */}




        <Route path="cbt_creator" element={<PrivateRoute />} >
          <Route path="dashboard" element={<Admindashboard />} />
          <Route path="dashboard" element={<Admindashboard />} />
 
          <Route path="cbt_img_library" element={<CbtImgLibrary />} />
          <Route path="api_key" element={<Apikey />} />
          <Route path="payment" element={<PaymentPage />} />
          <Route path="analytics" element={<Analytics />} />
 

          <Route path="cbt_data" element={<CbtData />} />
          <Route path="create_cbt" element={<Cbt />} />
          <Route path="cbt_question_edit" element={<CbtQuestionEdit />} />

          <Route path="profile" element={<Profile />} />
          <Route path="test_result/:cbt_pss_code" element={<TestResult />} />
          <Route path="test_data_upload/:cbt_pss_code" element={<ExcelUpload />} />


          <Route path="test_data/:cbt_pass_code/:cbt_test_id" element={<TestData />} />
          <Route path="question_transfer" element={<QuestionTransfer />} />


          <Route path="subscription/invitations" element={<UserInvitations />} />
          <Route path="subscription/users" element={<SubscriptionUsers />} />
          <Route path="subscription/join" element={<JoinSubscription />} />
          <Route path="subscription/join/:token" element={<JoinSubscription />} />
          <Route path="crypto-payment/:invoiceId" element={<CryptoPayment />} />


          
        </Route>
    {/* student cbt urls */}

      <Route path="participate" element={<PrivateRoute />} >
     
            <Route path="dashboard" element={<CbtPassCode />} />
            <Route path="verification" element={<CbtPassCodeVerification />} />
            <Route path="cbt_question" element={<CbtQuestion />} />
            <Route path="test_completion" element={<TestCompletion />} />
      </Route>


      </Routes>

  </BrowserRouter>
    </HelmetProvider>

  )
}


export default App;